import { defineMessages } from 'react-intl';

export const costSummaryMessages = defineMessages({
  receivedCostOfGoods: {
    defaultMessage: 'Received Cost of Goods:',
    id: '2yIhyz',
    description: 'Label for cost of goods based on received quantities',
  },
  receivedTotalCost: {
    defaultMessage: 'Received Total Cost:',
    id: 'lixres',
    description: 'Label for total cost including shipping, taxes, and tariffs based on received quantities',
  },
});
